module.exports = __webpack_public_path__ + "static/media/ALC_GKB_Web_-11.853bd109.JPG";